/* eslint-disable */

/** select columns of table "argo.vw_user_roles" */
export enum ArgoVwUserRolesSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  UserId = 'user_id'
}

/** select "argo_vw_user_roles_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.vw_user_roles" */
export enum ArgoVwUserRolesSelectColumnArgoVwUserRolesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_vw_user_roles_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.vw_user_roles" */
export enum ArgoVwUserRolesSelectColumnArgoVwUserRolesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

